<template>
  <div ref="variable_display_target" :class="[{ 'row': displayType === 'chip' }]">
    <div v-for="(el, index) in theModel"
      :key="getItemKey(el, index)"
      :ref="(elem) => { divs[index] = elem}"
      :class="[{ 'col': displayType !== 'chip' }, { 'var-dlst-item': displayType === 'chip' }]"
      >
      <q-chip
        v-if="displayType === 'chip'"
        color="grey-7"
        dense
        dark
        removable
        @remove="deleteItem(index)"
      >
        <div>
          <!-- remove first element in linkChains[index] on record-descriptor items because recursive-selector takes only their child .FieldFilters -->
          <variable-display-item v-if="[0, 1, 4, 9, 10].includes(modelType)" 
            v-model="theModel[index]" :modelType="modelType" :modelCategory="modelCategory" :compound-name="linearNames[index]" 
            :id-chain="linearParents[index] ? linkChains[index].slice(1) : linkChains[index]"
            :parameter-options="modelType === 4 ? (linearParents[index] ? (linearParents[index] as SelectionParameterFilterRecordSend).FieldFilters : modelValue) : null"
            :full-parameter-options="fullParameterOptions" :parent-element="linearParents[index]"
            :role-options="roleOptions"
          />
          <div v-else-if="[2,14].includes(modelType)" class="row full-width">
            <date-range-display-item v-model="theModel[index]" :modelType="2" />
          </div>
          <div v-else-if="modelType === 3" class="row full-width">
            <project-stage-display-item v-model="theModel[index]" :modelType="modelType" />
          </div>
          <div v-else-if="modelType === 12" :ref="(el) => { triggerEls[index] = el }" class="row full-width">
            <!-- <parameter-inline v-if="triggerEls && triggerEls[index]" :isRoot="true" :id="'paramd'+index" editable v-model="storageContainerModel[index]" 
              :root-param="parameter_global" :context-trigger="triggerEls[index]" move-to-body /> -->
            <storage-item-filter-wrapper v-if="triggerEls && triggerEls[index]" :id="'paramd'+index" v-model="theModel[index]" 
              :root-param="parameter_global" :show-clear-icon="!isContainerEmpty(index)" :trigger-el="triggerEls[index]" />
          </div>
        </div>
      </q-chip>
      <!-- justify-between  -->
      <div v-else-if="theModel[index].Descriptor || !hasSelectedChildren(index)" class="row full-width no-wrap">
        <!-- class="col" -->
        <div :class="{ 'col': modelType === 1 || modelType === 4 }">
          <!-- remove first element in linkChains[index] on record-descriptor items because recursive-selector takes only their child .FieldFilters -->
          <variable-display-item v-if="[0, 1, 4, 9, 10].includes(modelType)" 
            v-model="theModel[index]" :modelType="modelType" :modelCategory="modelCategory" 
            :role-options="roleOptions" :full-parameter-options="fullParameterOptions"
            :compound-name="linearNames[index]" :id-chain="linearParents[index] ? linkChains[index].slice(1) : linkChains[index]"
            :parameter-options="modelType === 4 ? (linearParents[index] ? (linearParents[index] as SelectionParameterFilterRecordSend).FieldFilters : modelValue) : null"
            :parent-element="linearParents[index]" @onDeleteClick="deleteItem(index)"
          />
          <div v-else :ref="(el) => { triggerEls[index] = el }" class="row justify-left full-width no-wrap">
            <q-toggle
              v-if="![2,3,14].includes(modelType) && theModel[index].Positive !== undefined"
              v-model="theModel[index].Positive"
              :class="`q-pa-none toggle-checkbox q-mr-none ${[3,12].includes(modelType) ?'unset-items-center' : 'items-center'}`"
              :style="`${[12].includes(modelType) ?'margin-top: -2px;' : ''}`"
              checked-icon="add"
              color="primary"
              label=""
              size="xs"
              unchecked-icon="remove"
            />
            <storage-item-filter-wrapper v-if="modelType === 12 && triggerEls && triggerEls[index]" :id="'param2d'+index" v-model="theModel[index]" 
              :root-param="parameter_global" :show-clear-icon="!isContainerEmpty(index)" :trigger-el="triggerEls[index]" />
          </div>
          
          <div v-if="modelType !== 12" class="row justify-left full-width">
            <date-range-display-item v-if="[2,14].includes(modelType)" v-model="theModel[index]" :modelType="2" 
            @onDeleteClick="deleteItem(index)" />
            <project-stage-display-item v-if="modelType === 3" v-model="theModel[index]" :modelType="modelType" 
            @onDeleteClick="deleteItem(index)" />
            <div class="row no-wrap items-center" v-else-if="modelType === 8">
              <q-checkbox
                size="sm"
                class="q-pa-none"
                toggle-indeterminate
                checked-icon="arrow_forward_ios"
                unchecked-icon="arrow_back_ios"
                indeterminate-icon="drag_handle"
                :false-value="2"
                :true-value="1"
                color="grey-7"
                :indeterminate-value="0"
                v-model="theModel[index].CompareType"
              />
              <!-- <q-input class="thin-input full-width" autofocus color="grey-4"
                debounce="500" outlined dense style="font-size: 14px !important; padding: 0 !important; margin-top: 2px;" 
                hide-bottom-space v-model="theModel[index].Value" 
                no-error-icon :rules="floatRules"
              /> -->
              <native-input
                :ref="'price_input'"
                style="min-width: 100px;"
                :model-value="theModel[index].Value"
                input-type="number"
                :show-border="true"
                :edit-on-click="true"
                @update:modelValue="
                  (newprice) => {
                    theModel[index].Value = +newprice
                  }
                "
              />
            </div>
          </div>
        </div>
        <q-btn
          v-if="![1,2,3,4,14].includes(modelType)"
          :class="'q-px-none q-ml-xs'+(modelType === 8 ? '' : ' unset-items-center')"
          flat
          dense
          :aria-label="$t('delete_filter')"
          icon="close"
          size="sm"
          tabindex="-1"
          color="accent"
          @click="deleteItem(index)"
        >
          <q-tooltip :delay="300" anchor="top middle" self="center middle">
            {{ $t('remove') }}
          </q-tooltip>
        </q-btn>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Emit, Prop, Vue, Watch } from 'vue-facing-decorator';
import { reactive } from 'vue';
import { SelectionFilterGroupSendCategory, SelectionFilterGroupSendDescriptor } from '@/models/etc/types';
import { foreachRecursive, mapRecursive } from '@/models/helpers/recursive';
import { CommonEntity } from '@/models/interfaces/common';
import VariableDisplayItem from './data-components/VariableDisplayItem.vue';
import DateRangeDisplayItem from './data-components/DateRangeDisplayItem.vue';
import ProjectStageDisplayItem from './data-components/ProjectStageDisplayItem.vue';
import _ from 'lodash';
import { V2ParameterValueType } from '@/models/etc/parameter-types';
import { generalStore } from '@/store/general';
import { StorageItemNameContainer } from '../../../models/interfaces/storage/storage-models';
import { storagePositionsStore } from '../../../store/storage/storage-positions';
import { ParameterInstanceContainer } from '../../../models/interfaces/parameters/parameter-models';
import { isInstanceContainerEmpty, isNumericFloat, mapCreateContainerToInstance } from '../../../models/helpers/parameter-helpers';
import StorageItemFilterWrapper from '../../multiedit/temporary/StorageItemFilterWrapper.vue';
import { i18n } from '../../../i18n';
import NativeInput from './NativeInput.vue';

/**
 * List component displaying v-model with delete functionality
 * */
@Component({
  name: 'VariableDisplayList',
  components: { VariableDisplayItem, DateRangeDisplayItem, ProjectStageDisplayItem, StorageItemFilterWrapper, NativeInput }
})
export default class VariableDisplayList extends Vue {
  // floatRules = [ (val: any) => (!val || !isNumericFloat(val)) || i18n.global.t('input_float') ]
  // dynamic item refs
  triggerEls: HTMLDivElement[] = reactive([]);
  
  @Prop({ default: SelectionFilterGroupSendDescriptor.Text })
  modelType!: SelectionFilterGroupSendDescriptor
  @Prop({ default: SelectionFilterGroupSendCategory.Name })
  modelCategory!: SelectionFilterGroupSendCategory
  // v-model input
  @Prop({ default: [] as any[] })
  modelValue!: any[]
  @Prop({ default: undefined })
  roleOptions?: CommonEntity[]
  // update v-model
  @Emit("update:modelValue") emitModelValue(arg: any[]) { return arg; }
  @Emit("itemDeleted") emitItemDeleted(arg: any) { return arg; }
  
  @Prop({ default: '' })
  displayType?: string
  @Prop({ default: false })
  displaySelected?: boolean

  genstore: any = undefined;
  storage_pos: any = undefined;
  parameter_global: ParameterInstanceContainer | undefined = undefined;

  // dynamic item refs
  divs: any[] = reactive([])

  created() {
    this.genstore = generalStore()
    this.storage_pos = storagePositionsStore();
  }

  get nameContainerMutated() {
    return _.cloneDeep(this.storage_pos?.currentItemNameContainer);
  }

  @Watch("nameContainerMutated", { deep: true })
  item_container_watcher(val: StorageItemNameContainer | undefined, oldval: StorageItemNameContainer | undefined) {
    if (_.isEqual(val, oldval)) { return }

    const that = this;
    if (val && val.ParameterContainer) {
      that.parameter_global = mapCreateContainerToInstance(val.ParameterContainer, true)[0]
    }
  }

  // Авто-выделение Selectable-предков уже выбранных Selectable-детей.
  // Раньше эта мутация шедулилась из геттера theModel через $nextTick — теперь
  // выведена в отдельный watcher и срабатывает только при реальном изменении modelValue,
  // не превращая computed в side-effect-генератор.
  //
  // ВАЖНО: проверяем именно `element.Selectable && element.Selected`. Без `element.Selectable`
  // watcher реагирует и на промежуточные не-Selectable узлы с residual `Selected=true`,
  // которые остаются после `deleteItem` (рекурсивная очистка в deleteItem трогает только
  // Selectable-узлы). Это приводит к rollback `parent.Selected = true` сразу после удаления
  // и крестик «не работает», пока страница не обновится.
  @Watch('modelValue', { deep: true, immediate: true })
  syncSelectedAncestors() {
    if (this.modelType !== 4 || !Array.isArray(this.modelValue)) return;
    this.$nextTick(() => {
      foreachRecursive(function a(element: any, parent: any): any | undefined {
        if (!element) return
        if (parent && element.Selectable && element.Selected && parent.Selectable && !parent.Selected) {
          parent.Selected = true
        }
        if (element.FieldFilters) {
          foreachRecursive(a, parent ?? element, element.FieldFilters)
        }
        return
      }, undefined, this.modelValue)
    })
  }

  // Чистый computed: собирает линейный список параметров и параллельные коллекции
  // (родители, compound-имена, цепочки id, fullOptions для формул) в локальные
  // переменные. Никаких side-effects на реактивных полях класса.
  get linearData(): {
    items: any[];
    parents: any[];
    names: string[];
    chains: any[][];
    fullOptions: any[];
  } {
    if (this.modelType !== 4) {
      return { items: [], parents: [], names: [], chains: [], fullOptions: [] };
    }
    const items: any[] = []
    const parents: any[] = []
    const names: string[] = []
    const chains: any[][] = []

    // fullOptions: рекурсивно фильтруем поддерево по Descriptor (Record/Bool/Number/Storage)
    const clone = _.cloneDeep(this.modelValue)
    const fullOptions = mapRecursive(function a(el: any) {
      const new_el = el
      new_el.FieldFilters = el.FieldFilters ? mapRecursive(a, el, el.FieldFilters).filter((e: any) => e) : []
      return [0, 3, 5, 12].includes(new_el.Descriptor) ? new_el : undefined
    }, undefined, clone).filter(el => el)

    const that = this
    foreachRecursive(function a(element: any, ctx: any): any | undefined {
      if (!element) return

      const new_name = ctx.name ? ctx.name + '.' + element.Parameter.Name : element.Parameter.Name
      const new_chain = [ ...ctx.chain, element.Parameter.Id ]
      if (!that.displaySelected || (element.Selectable && element.Selected)) {
        items.push(element)
        parents.push(ctx.parent)
        names.push(new_name)
        chains.push(new_chain)
      }
      if (element.FieldFilters) {
        foreachRecursive(a, {
          parent: ctx.parent ?? element,
          name: new_name,
          chain: new_chain,
        }, element.FieldFilters)
      }
      return
    }, { parent: undefined, name: '', chain: [] }, this.modelValue)

    return { items, parents, names, chains, fullOptions }
  }

  get theModel(): any[] {
    if (this.modelType === 4) return this.linearData.items
    return this.displaySelected ? this.modelValue.filter(el => el.Selectable && el.Selected) : this.modelValue
  }

  // Тонкие computed-обёртки над linearData — шаблон обращается к ним по тем же именам,
  // что раньше использовались как data-поля.
  get recursiveToLinear(): any[] { return this.linearData.items }
  get linearParents(): any[] { return this.linearData.parents }
  get linearNames(): string[] { return this.linearData.names }
  get linkChains(): any[][] { return this.linearData.chains }
  get fullParameterOptions(): any[] { return this.linearData.fullOptions }

  getItemKey(el: any, index: number): string {
    const base = `vds_${this.modelType}_${this.modelCategory}`;
    // Параметры (modelType=4): уникален путь от корня (linkChains[index]),
    // а не Parameter.Id — один и тот же id может встретиться в разных ветках
    // Record-родителей. С индексным ключом Vue переиспользует DOM-узлы при
    // reorder/удалении и тянет состояние q-menu/edit-режимов на чужие строки.
    if (this.modelType === 4) {
      const chain = this.linkChains?.[index];
      if (Array.isArray(chain) && chain.length > 0) {
        return `${base}_chain_${chain.join('_')}`;
      }
      const pid = el?.Parameter?.Id;
      if (pid != null && pid !== 0) return `${base}_p_${pid}`;
      return `${base}_idx_${index}`;
    }
    const id = el?.Entity?.Id ?? el?.Stage?.Id ?? el?.Storage?.Id ?? el?.Id;
    if (id != null && id !== 0) return `${base}_${id}`;
    return `${base}_idx_${index}`;
  }

  isContainerEmpty(model_index: number) {
    const item = this.theModel[model_index];
    if (item.VendorCode && item.VendorCode.trim()) return false;
    return item.Container && isInstanceContainerEmpty(item.Container, true);
  }

  deleteItem(del_index: number) {
    if (this.modelType === 4) {
      // ВАЖНО: после рефакторинга theModel/recursiveToLinear/linearParents — это
      // computed-обёртки над linearData. С displaySelected=true фильтр выкидывает
      // элементы, у которых Selected=false. Любая мутация Selected инвалидирует
      // computed-кеш, и следующий [del_index] начинает указывать на чужой элемент
      // или undefined. Поэтому ОДИН раз снимаем ссылки на element/parent ДО мутаций
      // и дальше работаем только с этими локальными ссылками (они указывают на узлы
      // дерева modelValue и переживают любые перерасчёты computed).
      const element = this.recursiveToLinear[del_index]
      const parent = this.linearParents[del_index]
      if (!element) return

      // Make sure that all descendant Selectable elements of de-selected Selectable elements 
      // are also de-selected
      // Only for root parameters (they have parent === undefined)
      if (!parent && element.FieldFilters) {
        foreachRecursive(function a(el: any, el_to_find: any): any | undefined {
          if (!el) return
          if (el.Selectable) {

            el.Selected = false;
            el.Positive != undefined && (el.Positive = false);
            // also clear conditions
            if (el.Conditions) {
              el.Conditions = []
            }
            if (el.Formulas) {
              el.Formulas = []
            }
            if (el.TextConditions) {
              el.TextConditions = []
            }
            if (el.EntityConditions) {
              el.EntityConditions = []
            }
            if (el.BoolFlags !== undefined) {
              el.BoolFlags = 0
            }
          }

          if (el.FieldFilters) {
            foreachRecursive(a, el_to_find, el.FieldFilters)
          }
          return
        }, undefined, element.FieldFilters)
      }
      element.Selected = false
      // also clear conditions
      if (element.Conditions) {
        element.Conditions = []
      }
      if (element.Formulas) {
        element.Formulas = []
      }
      if (element.TextConditions) {
        element.TextConditions = []
      }
      if (element.EntityConditions) {
        element.EntityConditions = []
      }
      if (element.BoolFlags !== undefined) {
        element.BoolFlags = 0
      }

      if (parent) {
        // check if this is last de-selected descendant of a selected root element - de-select the parent
        // Раньше тут был findIndex по recursiveToLinear + hasSelectedChildren(parent_index),
        // но индекс после мутаций сместится (см. комментарий в начале метода). Поэтому
        // обходим FieldFilters самого parent-элемента — это то же, что hasSelectedChildren
        // делает по сути, но без зависимости от индексов computed.
        let hasSelected = false
        if (parent.FieldFilters) {
          foreachRecursive(function a(el: any, el_to_find: any): any | undefined {
            if (!el) return
            if (el.Selectable && el.Selected) hasSelected = true
            if (el.FieldFilters) foreachRecursive(a, el_to_find, el.FieldFilters)
            return
          }, undefined, parent.FieldFilters)
        }
        if (!hasSelected) {
          parent.Selected = false
          // also clear conditions
          if (parent.Conditions) {
            parent.Conditions = []
          }
          if (parent.Formulas) {
            parent.Formulas = []
          }
          if (parent.TextConditions) {
            parent.TextConditions = []
          }
          if (parent.EntityConditions) {
            parent.EntityConditions = []
          }
        }
      }

      // Санитарная очистка residual Selected у промежуточных НЕ-Selectable узлов:
      // пост-ордером проходим по поддереву и сбрасываем Selected=false у не-Selectable узлов,
      // у которых не осталось Selectable && Selected потомка. Без этого промежуточный узел
      // (например, контейнер записи между корневым параметром и листом) остаётся Selected=true
      // и портит дерево, отправляемое на бэк, плюс раньше провоцировал rollback в watcher.
      // Возвращает true, если в поддереве остался хоть один Selectable && Selected узел.
      const cleanupResidualSelected = (nodes: any[]): boolean => {
        if (!Array.isArray(nodes)) return false
        let hasSelectableSelected = false
        for (const node of nodes) {
          if (!node) continue
          const childHas = node.FieldFilters ? cleanupResidualSelected(node.FieldFilters) : false
          if (node.Selectable && node.Selected) {
            hasSelectableSelected = true
          } else if (!node.Selectable && node.Selected && !childHas) {
            node.Selected = false
          }
          if (childHas) hasSelectableSelected = true
        }
        return hasSelectableSelected
      }
      if (!parent && element.FieldFilters) {
        cleanupResidualSelected(element.FieldFilters)
      }
      if (parent && parent.FieldFilters) {
        cleanupResidualSelected(parent.FieldFilters)
      }
    } else {
      console.log('item deleted '+del_index)
      this.emitItemDeleted(del_index)
    }
  }

  hasSelectedChildren(el_index: number) {
    let result = false
    if (this.modelType === 4) {
      // Check if at least some descendant Selectable elements of the element are selected
      // Only for root parameters (they have this.linearParents[del_index] === undefined) or record parameters
      // console.log(this.recursiveToLinear[el_index])

      if ((!this.linearParents[el_index] || this.recursiveToLinear[el_index].ValueType === V2ParameterValueType.Record) && 
      this.recursiveToLinear[el_index].FieldFilters) {
        foreachRecursive(function a(element: any, el_to_find: any): any | undefined {
          if (!element) return
          (element.Selectable && element.Selected) && (result = true)

          if (element.FieldFilters) {
            foreachRecursive(a, el_to_find, element.FieldFilters)
          }
          return
        }, undefined, this.recursiveToLinear[el_index].FieldFilters)
      }
    }
    return result
  }
}
</script>

<style lang="scss">
.var-dlst-item {
  cursor: pointer;
  &:hover {
    border-radius: 2px;
    background-color: rgb(241, 243, 225);
  }
}
</style>